import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_MOTOR } from '../../../services/search-service';
import { CuentasService } from '../../../services/cuentas-service';import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';
import * as moment from 'moment';
import { MotorAutocompleteComponent } from '../../../components/common/autocomplete';
import { CuentaAutocompleteComponent } from '../../../components/common/autocomplete';
import { ColaboradorAutocompleteComponent } from '../../../components/common/autocomplete';

@Component({
  selector: 'app-buscador-consignas-filter',
  templateUrl: './buscador-consignas-filter.component.html',
  styleUrls: ['./buscador-consignas-filter.component.scss']
})
export class BuscadorConsignasFilterComponent implements OnInit {

  public showFilters = false;

  private myNetwork = true;
  private wholeDay = false;

  private startDate = moment().startOf('day').toDate();
  private endDate = moment().startOf('day').add(1,'M').toDate();
  private minDate = moment(this.startDate).toDate();

  @ViewChild('startDatePicker') startDatePicker;
  @ViewChild('endDatePicker') endDatePicker;
  @Output() onFiltersApplied = new EventEmitter();

  @Input() showColaboradorAutocomplete = true;

  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;
  @ViewChild(CuentaAutocompleteComponent) cuentaAutocompleteComponent;
  //@ViewChild(MotorAutocompleteComponent) motorAutocompleteComponent;

  constructor(private dateAdapter: DateAdapter<Date>,
              private cuentasService: CuentasService,
              private searchService: SearchService) {
    // Set datepicker locale to the one expected so it doesn't swap the day and
    // month when opening the calendar again, we hide the associated input anyways
    this.dateAdapter.setLocale('en-us');
  }

  ngOnInit() {
  }

  onApply(e){
    // dont hide the filter window when clicking the apply button
    e.stopPropagation();

    let startDate = this.startDate;
    let endDate = this.endDate;
    if (this.wholeDay) {
      startDate = moment(this.startDate).startOf('day').toDate();
      endDate = moment(this.endDate).endOf('day').toDate();
    }

    this.onFiltersApplied.emit({
      startDate: startDate,
      endDate: endDate,
      cuentas: this.cuentaAutocompleteComponent.selectedCuentas,
      colaboradores: this.colaboradorAutocompleteComponent.selectedColaboradores,
      motores: [], //this.motorAutocompleteComponent.selectedMotores,
      myNetwork: this.myNetwork
    });
  }

  showStartDatePicker(){
    this.startDatePicker.open();
  }

  showEndDatePicker(){
    this.endDatePicker.open();
  }

  cleanFilters(e) {
    this.startDate = moment().startOf('day').toDate();
    this.endDate = moment().startOf('day').add(1,'M').toDate();
    this.colaboradorAutocompleteComponent.selectedColaboradores = [];
    //this.motorAutocompleteComponent.selectedMotores = [];
    this.cuentaAutocompleteComponent.selectedCuentas = [];
    this.myNetwork = true;

    this.onApply(e);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/buscador/buscador-consignas-filter/buscador-consignas-filter.component.ts